import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		formPopupOfacNotification_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		formPopupOfacNotification_title: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			margin: theme.spacing(2),
		},
		formPopupOfacNotification_link: {
			color: theme.palette.primary.main,
			textDecoration: 'none',
		},
	});
});

export default useStyles;
